import { PaymentCard } from 'components';
import React, { Component } from 'react';
import ContactModal from 'scenes/Project/components/ContactModal';
import { Container } from 'utils';
import styled from '@emotion/styled';
import { Colors, device } from 'utils';
import { Donation, InfoForm } from 'scenes/Donation/components';

const DonationFormWrapper = styled.div`
  overflow-anchor: none;
  overscroll-behavior: none;
  //   display: flex;
  margin-top: 5px;
  @media ${device.allMobile} {
    flex-wrap: wrap;
    margin-top: 25px;
    margin-bottom: 25px;
  }

  .paymentCard {
    label {
      font-size: 22px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .ant-row {
      display: block;
    }
    .payment-card {
      max-width: 100%;

      .ant-form-item-control-input-content {
        @media ${device.allMobile} {
          max-width: 200px;
        }
        div {
          max-width: 100%;
        }
        input {
          font-size: 18px;
        }
        #cardNumber {
          width: 300px;
        }
      }
    }
  }

  h1 {
    font-weight: bold;
  }
  .zahlungsmethode {
    h2 {
      font-size: 22px;
      font-weight: bold;
      @media ${device.allMobile} {
        font-size: 16px;
      }
    }
    & > div {
      display: flex;
      justify-content: space-around;
      font-size: 35px;
      margin-bottom: 20px;
      @media ${device.allMobile} {
        font-size: 22px;
      }
    }
  }
  .deine-label {
    input {
      border-radius: 15px;
      padding: 15px;
    }
  }
  .gesamtsumme-button {
    @media ${device.allMobile} {
      min-width: 100%;
    }
  }
  .gesamtsumme {
    display: flex;
    justify-content: space-between;
    h2 {
      font-size: 30px;
      font-weight: bold;
      margin: 0;
      @media ${device.allMobile} {
        font-size: 20px;
      }
    }
    p {
      font-size: 30px;
      font-weight: bold;
      margin: 0;
      @media ${device.allMobile} {
        font-size: 20px;
      }
    }
    & + p {
      font-size: 22px;
      margin-bottom: 30px;
      @media ${device.allMobile} {
        font-size: 16px;
      }
    }
  }
  .danke {
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    max-height: 500px;
    p {
      text-align: left;
      font-size: 22px;
      @media ${device.laptop} {
        font-size: 18px;
      }
      @media ${device.allMobile} {
        font-size: 16px;
      }
    }
  }
  & > div {
    width: 100%;
    // padding: 20px 0px;
    // padding-top: 20px;
    &:first-of-type {
      padding-left: 0;
    }
    &:nth-of-type(2) {
      padding-right: 0;
    }
    @media ${device.allMobile} {
      width: 100%;
    }
    @media ${device.allMobile} {
      padding: 0;
    }
    @media ${device.tablet} {
      margin-top: 0;
    }
    .ant-checkbox-wrapper {
      a {
        color: ${Colors.secondaryColor};
        margin: 0 3px;
        display: inline-block;
        &:hover {
          text-decoration: underline;
        }
      }
    }
    .freiwilliges-input {
      position: relative;
      .anticon {
        position: absolute;
        right: 150px;
        font-size: 22px;
        top: 50%;
        transform: translateY(-50%);
        @media ${device.allMobile} {
          font-size: 16px;
          right: 10px;
        }
      }
    }
    .donation-input {
      display: flex;
      padding: 20px 20px 20px 20px;
      border: 1px solid ${Colors.steel};
      border-radius: 10px;
      justify-content: space-between;
      align-items: center;
      @media ${device.allMobile} {
        padding: 10px;
      }
      input,
      .ant-input-group-addon {
        border: 0;
        background: transparent;
        font-weight: bold;
        font-size: 22px;
        @media ${device.allMobile} {
          font-size: 16px;
        }
      }

      .ant-form-item-control {
        text-align: right;
        @media ${device.tablet} {
          max-width: 97px;
        }
        @media ${device.allMobile} {
          max-width: 55%;
        }
        input {
          font-weight: bold;
          font-size: 22px;
          padding-right: 10px;
          text-align: right;
          max-width: 100%;
          @media ${device.allMobile} {
            font-size: 16px;
            // max-width: 150px;
          }
          @media ${device.tablet} {
            font-size: 16px;
            max-width: 104px;
          }
        }
        .ant-input-group-addon {
          padding: 0;
          text-align: left;
        }
      }
      .ant-form-item-label {
        width: 40%;
        display: inline-block;
        text-align: left;
        padding: 0;
        @media ${device.tablet} {
          width: 60%;
        }
        @media ${device.allMobile} {
          width: 45%;
          max-width: 45%;
        }
        label {
          font-size: 22px;
          font-weight: bold;
          @media ${device.allMobile} {
            font-size: 16px;
            line-height: 1;
          }
          &:before,
          &:after {
            content: none;
          }
        }
      }
    }
  }

  .show-options {
    .donation-input {
      .ant-form-item-label {
        width: 35%;
        @media ${device.laptop} {
          width: 31%;
          max-width: 31%;
        }
        @media ${device.allMobile} {
          width: 120px;
          max-width: 120px;
        }
        @media ${device.tablet} {
          width: 35%;
          max-width: 35%;
        }
      }
      .ant-form-item-control {
        max-width: 80%;
        @media ${device.laptop} {
          width: 69%;
          max-width: 69%;
        }
        @media ${device.tablet} {
          width: 65%;
          max-width: 65%;
        }
        @media ${device.allMobile} {
          width: fit-content;
          max-width: fit-content;
          margin-top: 10px;
        }
      }
    }
    .freiwilliges-option {
      @media ${device.allMobile} {
        display: flex;
        justify-content: flex-end;
        max-width: 200px;
        margin-left: auto;
        overflow: scroll;
      }

      div {
        display: inline-block;
        button {
          margin: 0;
          @media ${device.allMobile} {
            padding: 5px 5px;
            font-size: 12px;
            border-radius: 5px;
            min-width: 36px;
          }
        }
        & + div {
          margin-left: 15px;
          @media ${device.tablet} {
            margin-left: 10px;
          }
          @media ${device.allMobile} {
            margin-left: 10px;
          }
        }
      }
    }
  }
`;

class Freitag extends Component {
  constructor(props) {
    super(props);
    this.state = {
      project_id: null,
      recurring_check: false,
      isLoading: true,
      error: null,
      showModal: false,
      showPaymentForm: false,
      currentView: null,
      showOption: false,
      otherOption: false,
      donation: parseFloat(5).toFixed(2),
      freiwilliges: 0,
      allRewards: [],
      selectedRewards: [],
      addressRequired: false,
      clientSecret: null,
    };
  }

  donationFormRef = React.createRef();
  scrollToTop = () => {
    try {
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
      }
    } catch (_) {}
    // Force scroll to top in this frame
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  };
  startTopGuard = (duration = 6000) => {
    // Prevent repeated guards
    if (this._guardCleanup) this._guardCleanup();
    const enforceTop = () => {
      try {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      } catch (_) {}
    };
    const onFocusIn = () => enforceTop();
    const onScroll = () => enforceTop();
    const stopGuardOnUserAction = () => {
      if (this._guardCleanup) this._guardCleanup();
    };
    // Kick immediately and next frame
    enforceTop();
    requestAnimationFrame(enforceTop);
    document.addEventListener('focusin', onFocusIn, true);
    window.addEventListener('scroll', onScroll, { passive: true });
    // Stop the guard if user interacts
    window.addEventListener('pointerdown', stopGuardOnUserAction, {
      once: true,
    });
    window.addEventListener('keydown', stopGuardOnUserAction, { once: true });
    window.addEventListener('wheel', stopGuardOnUserAction, { once: true });
    window.addEventListener('touchstart', stopGuardOnUserAction, {
      once: true,
    });
    const timer = setTimeout(() => {
      document.removeEventListener('focusin', onFocusIn, true);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('pointerdown', stopGuardOnUserAction);
      window.removeEventListener('keydown', stopGuardOnUserAction);
      window.removeEventListener('wheel', stopGuardOnUserAction);
      window.removeEventListener('touchstart', stopGuardOnUserAction);
      this._guardCleanup = null;
    }, duration);
    this._guardCleanup = () => {
      clearTimeout(timer);
      document.removeEventListener('focusin', onFocusIn, true);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('pointerdown', stopGuardOnUserAction);
      window.removeEventListener('keydown', stopGuardOnUserAction);
      window.removeEventListener('wheel', stopGuardOnUserAction);
      window.removeEventListener('touchstart', stopGuardOnUserAction);
      this._guardCleanup = null;
    };
  };
  async componentDidMount() {
    this.scrollToTop();
    this.startTopGuard(6000);
    const requestOptions = {
      method: 'POST',
      redirect: 'follow',
      body: JSON.stringify({ project_name: 'freitag' }),
    };
    try {
      const response = await fetch(`find_ramadan`, requestOptions);
      this.setState({
        project_id: response.id,
        recurring_check: response.recurring_check,
      });
      return { response };
    } catch (error) {
      return await Promise.reject({ errors: error });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.project_id !== prevState.project_id ||
      this.state.currentView !== prevState.currentView ||
      this.state.showPaymentForm !== prevState.showPaymentForm
    ) {
      // Defer to next paint to avoid late layout pushing us down
      requestAnimationFrame(() => this.scrollToTop());
      setTimeout(() => this.scrollToTop(), 200);
      this.startTopGuard(6000);
    }
  }

  componentWillUnmount() {
    if (this._guardCleanup) this._guardCleanup();
  }

  handleCLientSecret = (value) => {
    this.setState({ clientSecret: value });
  };
  handelCloseModal = () => {
    this.setState({ showModal: false });
    document.body.style.overflowY = 'unset';
  };

  handelShowModal = () => {
    this.setState({ showModal: true });
    document.body.style.overflowY = 'hidden';
  };
  setDonationState = (donation) => {
    this.setState({ donation });
  };
  setCurrentViewState = (currentView) => {
    this.setState({ currentView });
  };
  setShowOptionState = (showOption) => {
    this.setState({ showOption });
  };
  setOtherOptionState = (otherOption) => {
    this.setState({ otherOption });
  };
  setFreiwilligesState = (freiwilliges) => {
    this.setState({ freiwilliges });
  };
  setShowPaymentFormState = (showPaymentForm) => {
    this.setState({ showPaymentForm });
  };
  setAllRewards = (allRewards) => {
    this.setState({ allRewards });
  };
  setSelectedRewards = (selectedRewards) => {
    this.setState({ selectedRewards });
  };
  setAddressRequired = (selectedRewards) => {
    let isAddressRequired = false;
    selectedRewards.forEach((reward) => {
      isAddressRequired = isAddressRequired || reward.address_required;
    });
    this.setState({
      addressRequired: isAddressRequired,
    });
  };

  render() {
    const {
      showPaymentForm,
      donation,
      freiwilliges,
      showOption,
      otherOption,
      currentView,
    } = this.state;
    const {
      location: { search },
      match: {
        params: { id },
      },
    } = this.props;
    const project = { url: this.state.project_id, title: 'freitag' };
    const originalDonation = Number(
      new URLSearchParams(search).get('donation') || 5
    );
    const originalRewardId = Number(
      new URLSearchParams(search).get('rewardId') || 0
    );

    return (
      <>
        <ContactModal />
        <Container>
          {this.state.project_id && (
            <div className="inner_div" id="payment_card">
              <DonationFormWrapper>
                <Donation
                  showPaymentForm={showPaymentForm}
                  showOption={showOption}
                  otherOption={otherOption}
                  originalDonation={originalDonation}
                  donation={donation}
                  freiwilliges={freiwilliges}
                  setDonationState={this.setDonationState}
                  setCurrentViewState={this.setCurrentViewState}
                  setShowOptionState={this.setShowOptionState}
                  setOtherOptionState={this.setOtherOptionState}
                  setFreiwilligesState={this.setFreiwilligesState}
                  setShowPaymentFormState={this.setShowPaymentFormState}
                  projectId={this.state.project_id}
                  recurringCheck={this.state.recurring_check}
                  isTicketable={project?.is_ticketable}
                  originalRewardId={originalRewardId}
                  setAllRewards={this.setAllRewards}
                  setSelectedRewards={this.setSelectedRewards}
                  allRewards={this.state.allRewards}
                  selectedRewards={this.state.selectedRewards}
                  formRef={this.donationFormRef}
                  setAddressRequired={this.setAddressRequired}
                  handleCLientSecret={this.handleCLientSecret}
                  handelShowModal={this.handelShowModal}
                  project={project}
                  project_name={'freitag'}
                  embeddedAction={true}
                />
                <InfoForm
                  setCurrentViewState={this.setCurrentViewState}
                  amount={Number(donation)}
                  tips={Number(freiwilliges)}
                  project={project}
                  projectId={this.state.project_id}
                  donationFormRef={this.donationFormRef}
                  selectedRewards={this.state.selectedRewards}
                  addressRequired={this.state.addressRequired}
                  clientSecret={this.state.clientSecret}
                  handleCLientSecret={this.handleCLientSecret}
                  // handleCLientSecret={handleCLientSecret}
                  embeddedAction={true}
                />
                {showPaymentForm && currentView === 'payment' && (
                  <div className="paymentCard zahlungsmethode">
                    <PaymentCard />
                  </div>
                )}
              </DonationFormWrapper>
            </div>
          )}
          <div style={{ height: 1 }} />
        </Container>
      </>
    );
  }
}

export default Freitag;
